module.exports = __webpack_public_path__ + "static/media/Eterno Modular Sofa Console_Cloud.4220f198.png";